export default "__VITE_ASSET__B4WpHS3T__"